import React from 'react'
import styled from 'styled-components'
import nextoriesLogoVerticalRvb from '../../../assets/nextories-logo-vertical-rvb.svg'
import { HeadingWithDash } from '../Common/HeadingWithDash'

const HistoryContainerFullWidth = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  background-color: #f3f3f3;
`

const HistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 916px;
`

const HistoryContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 24px;
  gap: 32px;
  background-color: #fff;
`

const TextContainer = styled.div`
  width: 100%;

  @media (min-width: 997px) {
    width: 586px;
  }

  h2 {
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    color: #000;
  }

  p {
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    color: #000;
  }
`

export const History = () => (
  <HistoryContainerFullWidth>
    <HistoryContainer>
      <HeadingWithDash text="Pourquoi SeLoger a choisi Nextories&nbsp;?" />
      <HistoryContent>
        <img src={nextoriesLogoVerticalRvb} width={250} alt="" />
        <TextContainer>
          <h2>Pourquoi SeLoger a choisi Nextories&nbsp;?</h2>
          <p>
            Parce que déménager va bien au delà de simplement transporter des meubles et des cartons, nous avons choisi le partenaire qui facilitera et accompagnera gratuitement
            votre projet de A à Z.
          </p>
          <p>
            Nextories est la plateforme de référence pour trouver votre déménageur en France. Leurs experts sélectionnent pour vous les sociétés les plus qualifiées parmi un réseau
            de 250 déménageurs certifiés. Pour votre nouveau départ, Nextories vous propose un accompagnement sur mesure pour vous aider à trouver les meilleurs déménageurs.
          </p>
          <p>Enfin, Nextories est la plateforme leader en termes de qualité, en atteste leurs retours affichant une note de 4,9/5.</p>
        </TextContainer>
      </HistoryContent>
    </HistoryContainer>
  </HistoryContainerFullWidth>
)
